import useFeatureSettingsUpdate from './useFeatureSettingsUpdate';

export default function useDailyReportSettingsUpdate() {
  return useFeatureSettingsUpdate('dailyProjectReport');
}
